/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Form as Formiker, Field as Fieldmik, Formik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Input, Button, Grid, Header, Segment, Divider, Loader, Dimmer, Message, Icon, Modal } from 'semantic-ui-react'
import { DateData } from '../apiInputComponent/dateData';
import Tyre from './jobcardTypeComponent/tyre';
import MyVehicleNumber from './../apiInputComponent/myVehicleNo'
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';
import Battery from './jobcardTypeComponent/battery';
import MyBranch from '../apiInputComponent/myBranch';
import MyVendor from '../apiInputComponent/myVendor';
import UploadFile from '../apiInputComponent/fileUpload';
import { MyInput } from '../apiInputComponent/myInput';
import moment from 'moment';
import JobcardHistory from './jobcardTypeComponent/jobcardHistory';
import Services from './jobcardTypeComponent/service';
import MyJobcardType from '../apiInputComponent/myjobcardType';
import JobcardActivity from '../apiInputComponent/jobcardActivity'
import AddProduct from './addProduct';
import cogoToast from 'cogo-toast';
import { jobcardTitles, jobCardValidations } from '../../utils/validationConstant';
import { DATE_FORMATS } from '../../utils/constants';

export const InsertJobcard = () => {
  const [isadded, setisadded] = useState(false)
  const [vehicleInfo, setvehicleInfo] = useState([])
  const [batteryInfo, setBatteryInfo] = useState([])
  const [switchOff, setswitchOff] = useState(false)
  const [latestHistory, setLatestHistory] = useState([])
  const [tyreNumber, settyreNumber] = useState([])
  const [jbConditionId, setjbConditionId] = useState({})
  const [valueForApproval, setValueForApproval] = useState('')
  const [condroleId, setcondroleId] = useState([])
  const [billNoExists ,setBillNoExists] =useState(false)
  const [vehicleSelected, setVehicleSelected] = useState([])

  const checkInvoiceNo = (data) => {
    let val = data.target.value
    if(val){
      let userId = localStorage.getItem('userId')
      let customerNo = localStorage.getItem('customerNo')
      const data = {
        "customerNo": customerNo,
        "userId": userId,
        "invoiceNo": val
      }
      Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getBillNoUniqueness`, data, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": localStorage.getItem('apiToken'),
          "Access-Control-Allow-Origin": "*"
        }
      }).then((res) => {
        if (res.data.data.length > 0) {
          cogoToast.error('Bill No Already Exists')
          setBillNoExists(true)
        } else if(res.data.data.length == 0) {
          setBillNoExists(false)
        }
      }).catch(() => {
      })
    }
  }

  let fetchLatestHistory = (data) => {
    setswitchOff(false)
    if (data && data?.length > 0) {
      setLatestHistory(data)
      if (data.length > 0) {
        data.map((o) => {
          if (o.jb_approval_status != null) {
            if (o.vehicleId === vehicleSelected && o.jb_approval_status.approvalStatus < 3) {
              setswitchOff(true)
              // values.jobcardTypeName = o.jb_type.jobCardType
            }
          } else if (o.jb_approval_status === null) {
            setswitchOff(true)
          }
        })
      } else if (data.length === 0) {
        setswitchOff(false)
      }
    } else {
      setLatestHistory([])
    }
  }

  Array.prototype.sum = function (prop) {
    var total = 0
    for (var i = 0, _len = this.length; i < _len; i++) {
      total += this[i][prop]
    }
    return total
  }

  let blockVehicle = (vehicleId) => {
    setswitchOff(false)
    if (latestHistory.length > 0) {
      latestHistory.map((o) => {
        if (o.jb_approval_status != null) {
          if (o.vehicleId === vehicleId && o.jb_approval_status.approvalStatus < 3) {
            setswitchOff(true)
            // values.jobcardTypeName = o.jb_type.jobCardType
          }
        } else if (o.jb_approval_status === null) {
          setswitchOff(true)
        }
      })
    } else if (latestHistory.length === 0) {
      setswitchOff(false)
    }
  }

  let getRoleId = (childData) => {
    setcondroleId(childData)
  }

  let getTyrNo = (childData) => {
    settyreNumber(childData)
  }

  let getJbConditionId = (childData) => {
    setjbConditionId(childData)
  }

  let getValueForApproval = (childData) => {
    setValueForApproval(childData)
  }

  let removeProductFromlist = (list) => {
    list.productDetails.splice(0, list.productDetails.length)
    list.productDetails.push({ productName: '', startDate: '', endDate: '', hsnCode: '', sacCode: '', quantity: 1, rate: '', discount: '', discountType: "1", iGstPercent: 0, iGst: 0, cGstPercent: 0, cGst: '', sGstPercent: 0, sGst: 0, taxable: 0, amount: 0 })
  }

  const validateSchema = yup.object({
    jobcardType: yup.string().required(jobCardValidations.JOBCARD_TYPE_REQUIRED),
    jobcardActivity: yup.string().optional().nullable(),
    refNo: yup.string().optional(),
    vehicleNumber: yup.string().required(jobCardValidations.VEHICLE_NO_REQUIRED),
    branch: yup.string().required(jobCardValidations.BRANCH_REQUIRED),
    dealer: yup.string().required(jobCardValidations.VENDOR_REQUIRED),
    invoiceNumber: yup.string().required(jobCardValidations.BILL_NO_REQUIRED),
    quotationNumber: yup.string().matches(/^([A-Za-z-0-9])+$/, jobCardValidations.INVALID_CHARACTERS),
    quotationAmount: yup.string().matches(/^[0-9]+$/, jobCardValidations.ONLY_NO_REQUIRED),
    productDetails: yup.array().of(
      yup.object().shape({
        productName: yup.string().required(jobCardValidations.ADD_PRODUCT_SERVICE),
        quantity: yup.number().required(jobCardValidations.QUANTITY_IS_REQUIRED).min(1, jobCardValidations.SHOULD_BE_MORE_THAN_0),
        rate: yup.number().required(jobCardValidations.RATE_IS_REQUIRED).min(0, jobCardValidations.SHOULD_BE_MORE_THAN_1)
      })
    ),
    inDate: yup.string().nullable().required(jobCardValidations.VEHICLE_IN_DATE_REQUIRED),
    previousMeterReading: yup.number().optional(),
    previousMeterReadingCheck: yup.number().optional(),
    meterReading: yup.number().required(jobCardValidations.METER_READING_REQUIRED).min(yup.ref('previousMeterReadingCheck')),
    adjustAmt: yup.string().matches(/^[0-9]+$/, jobCardValidations.ONLY_NO_REQUIRED),
    outDate: yup.string().nullable().required(jobCardValidations.VEHICLE_OUT_DATE_REQUIRED)
  })

  return (
    <>
      {isadded ?
        <Dimmer active inverted>
          <Loader size='massive'>Loading</Loader>
        </Dimmer> : ''
      }
      <Formik
        initialValues={{
          jobcardNumber: '',
          refNo: '',
          branch: '',
          jobcardType: '',
          jobcardTypeName: '',
          jobcardActivity: '',
          meterReading: '',
          previousMeterReading: 0,
          previousMeterReadingCheck: 0,
          inDate: new Date(),
          vehicleNumber: '',
          outDate: '',
          dealer: '',
          quotationNumber: '',
          quotationAmount: '',
          adjustmentAmount: '',
          subTotal: "",
          finalAmount: '',
          quotation: '',
          invoiceNumber: '',
          invoiceDate: '',
          tyreDetails: [],
          tyreDetailsFromAdd: [],
          batteryDetails: {
            productInvId: '',
            serialNo: '',
            oldSerialNumber: '',
            newSerialNo: '',
            oldBatteryMapId: '',
            flag: 0,
            checkboxSelect: false,
            newInstallationDate: new Date()
          },
          productDetails: [{
            productName: '',
            startDate: '',
            endDate: '',
            hsnCode: '',
            sacCode: '',
            quantity: 1,
            rate: 0,
            discount: '',
            discountType: "1",
            iGstPercent: 0,
            iGst: 0,
            cGstPercent: 0,
            cGst: '',
            sGstPercent: 0,
            sGst: 0,
            taxable: 0,
            amount: 0,
          }],
          invoiceUpload: '',
          customerNotes: ''
        }}

        validationSchema={validateSchema}

        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
          setisadded(true);

          let noErrorInForm = true;

          let psLineItems = [];
          values.productDetails.map((product, index) => {
            let temp = {}
            temp.psCode = product.productCode
            temp.psId = product.productName
            temp.quantity = product.quantity
            temp.rate = product.rate
            temp.psPrice = product.rate
            temp.psAmount = product.rate * product.quantity
            temp.igstPercent = product.iGstPercent
            temp.igstAmount = product.iGst
            temp.cgstPercent = product.cGstPercent
            temp.cgstAmount = product.cGst
            temp.sgstPercent = product.sGstPercent
            temp.sgstAmount = product.sGst
            temp.gstPercentage = product.iGstPercent || (product.cGstPercent * 2)
            temp.gstAmount = product.iGst || (product.cGst * 2)
            temp.discount = product.discount
            temp.finalDiscount = product.discount
            temp.discountType = product.discountType
            temp.taxableAmount = product.rate * product.quantity - product.discount
            temp.totalAmt = product.amount
            psLineItems[index] = temp
          });

          let tyreItems = [];
          let selectedRemoveTyre = 0;
          let tyreChangesCheckFlag = 0;
          if (values.jobcardActivity == 1) {
            values.tyreDetailsFromAdd.map((tyre, index) => {
              let temp = {}
              if (values.jobcardActivity == 1 && tyre?.flag == 1 && (tyre?.serialNo?.serialNo?.length > 0)) {

                tyreChangesCheckFlag++;

                if (tyre?.tyreRunNew?.length > 0) {
                  temp.tyreRun = tyre.tyreRunNew
                } else {
                  temp.tyreRun = tyre.tyreRun
                }
                if (!tyre.installationDate.split(" ")[0].match(/(?!3[2-9]|00|02-3[01]|04-31|06-31|09-31|11-31)[0-3][0-9]-(?!1[3-9]|00)[01][0-9]-(?!10|28|29)[12][089][0-9][0-9]/)) {
                  temp.installationDate = tyre.newInstallationDate
                } else {
                  temp.installationDate = tyre.installationDate
                }
                temp.tyrePositionId = tyre.tyrePositionId
                temp.tyrePostionName = tyre.tyrePositionName
                temp.productInvId = tyre.serialNo.productInventoryId
                temp.serialNo = tyre.serialNo.serialNo

                tyreItems[index] = temp
              }
            });
          } else if (values.jobcardActivity == 2 || values?.jobcardActivity == 3) {
            values.tyreDetails.map((tyre, index) => {
              let temp = {}
              if (values.jobcardActivity == 2 && tyre.checkboxSelect) {
                tyreChangesCheckFlag++;

                temp.tyreRun = tyre.tyreRun
                temp.tyrePositionId = tyre.tyrePositionId
                temp.installationDate = tyre.installationDate
                temp.tyrePostionName = tyre.tyrePositionName
                temp.oldTyreMapId = tyre.oldTyreMapId
                temp.oldSerialNo = tyre.oldSerialNo
                temp.old_serial_no = tyre.oldSerialNo
                selectedRemoveTyre++;
                //temp.productInvId = tyre.serialNo.productInvId
                //temp.serialNo = tyre.serialNo.serialNo
                noErrorInForm = true;

                tyreItems[index] = temp
              } else if (values.jobcardActivity == 2 && !tyre.checkboxSelect && selectedRemoveTyre == 0) {
                noErrorInForm = false;
              }
              else if (values.jobcardActivity == 3 && tyre?.flag == 1 && (tyre?.serialNo?.serialNo?.length > 0)) {
                tyreChangesCheckFlag++;
                temp.tyreRun = tyre.tyreRun
                temp.tyrePositionId = tyre.tyrePositionId
                if (tyre?.installationDate && !tyre.installationDate.split(" ")[0].match(/(?!3[2-9]|00|02-3[01]|04-31|06-31|09-31|11-31)[0-3][0-9]-(?!1[3-9]|00)[01][0-9]-(?!10|28|29)[12][089][0-9][0-9]/)) {
                  temp.installationDate = tyre.newInstallationDate
                } else {
                  temp.installationDate = tyre.installationDate
                }
                temp.tyrePostionName = tyre.tyrePositionName
                temp.oldTyreMapId = tyre.oldTyreMapId
                temp.oldSerialNo = tyre.oldSerialNo
                temp.old_serial_no = tyre.oldSerialNo
                temp.productInvId = tyre.serialNo.productInventoryId
                temp.serialNo = tyre.serialNo.serialNo
                tyreItems[index] = temp
              }

            });
          }


          if (values.jobcardActivity == 2 && !noErrorInForm && values.jobcardTypeName == "TYRE") {
            cogoToast.error('Please Choose TYRE To Remove..');
            noErrorInForm = false;
          } else if (tyreChangesCheckFlag == 0 && values.jobcardTypeName == "TYRE") {
            cogoToast.error('Please Perform Tyre Jobcard Action..');
            noErrorInForm = false;
          }

          let batteryItem = [];
          let batteryChangesCheckFlag = 0;
          if (values.jobcardActivity == 4) {
            batteryChangesCheckFlag++;
            let temp = {}
            temp.productInvId = values.batteryDetails.serialNo.productInventoryId
            temp.serialNo = values.batteryDetails.serialNo.serialNo
            temp.batteryInstallationDate = values?.batteryDetails?.newInstallationDate ? moment(values?.batteryDetails?.newInstallationDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD') : new Date(),
            //temp.oldSerialNo = values.batteryDetails.oldSerialNumber
            //temp.oldBatteryMapId = values.batteryDetails.oldBatteryMapId

            batteryItem.push(temp)
          }
          else if (values.jobcardActivity == 5 && values.batteryDetails.checkboxSelect && values.jobcardTypeName == "BATTERY") {
            let temp = {}
            batteryChangesCheckFlag++;
            //temp.productInvId = values.batteryDetails.serialNo.productInventoryId
            //temp.serialNo = values.batteryDetails.serialNo.serialNo
            temp.oldSerialNo = values.batteryDetails.oldSerialNumber
            temp.oldBatteryMapId = values.batteryDetails.oldBatteryMapId
            noErrorInForm = true;
            batteryItem.push(temp)
          }
          else if (values.jobcardActivity == 6) {
            batteryChangesCheckFlag++;
            let temp = {}
            temp.productInvId = values.batteryDetails.serialNo.productInventoryId
            temp.serialNo = values.batteryDetails.serialNo.serialNo
            temp.oldSerialNo = values.batteryDetails.oldSerialNumber
            temp.oldBatteryMapId = values.batteryDetails.oldBatteryMapId
            temp.installationDate = values.batteryDetails.newInstallationDate ? moment(values.batteryDetails.newInstallationDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD') : '',

            batteryItem.push(temp)
          }

          if (values.jobcardActivity == 5 && !values.batteryDetails.checkboxSelect && values.jobcardTypeName == "BATTERY") {
            cogoToast.error('Please Choose Battery To Remove..');
            noErrorInForm = false;
          } else if (values.jobcardTypeName == "BATTERY" && batteryChangesCheckFlag == 0) {
            cogoToast.error('Please Perform Battery Jobcard Action..');
            noErrorInForm = false;
          }

          /* if (latestHistory?.[0]?.meterReading && values?.meterReading && (Number(values?.meterReading) <= Number(latestHistory?.[0]?.meterReading))) {
            cogoToast.error('Please enter correct meter reading..');
            noErrorInForm = false;
          } */


          tyreItems.filter(n => n)

          let jobcardData = JSON.stringify
            ({
              jobCardNo: values.jobcardNumber,
              api_token: localStorage.getItem('apiToken'),
              userId: localStorage.getItem('userId'),
              customerNo: localStorage.getItem('customerNo'),
              jobCardTypeId: values.jobcardType,
              jobcardActivityId: values.jobcardActivity,
              refNo: values.refNo,
              vehicleId: values.vehicleNumber,
              branchId: values.branch.id,
              previousMeterReading: values.previousMeterReading,
              meterReading: values.meterReading ? values.meterReading : latestHistory ? latestHistory[0].meterReading : '',
              vendorId: values.dealer,
              batteryDetails: values?.batteryDetails ? batteryItem : null,
              tyreDetails: tyreItems.filter(n => n),
              vehicleInDate: values.inDate ? moment(values.inDate).format('DD-MM-YYYY') : '',
              vehicleOutDate: values.outDate ? moment(values.outDate).format('DD-MM-YYYY') : '',
              invoiceDetails: {
                quotationNo: values.quotationNumber,
                quotationAmt: values.quotationAmount,
                quotationFile: values.quotation ? values.quotation?.base64?.split(',')?.[1] : "",
                invoiceNo: values.invoiceNumber,
                invoiceDate: values.invoiceDate ? moment(values.invoiceDate).format('DD-MM-YYYY') : '',
              },
              docFile: values.invoiceUpload ? values.invoiceUpload?.base64?.split(',')?.[1] : '',
              remarks: values.customerNotes,
              productDetails: psLineItems,
              totalAmt: values.finalAmount,
              adjustmentAmt: values.adjustmentAmount,
              approverRoleId: condroleId,
              jbConditionId: jbConditionId ? jbConditionId.jbConditionId : '',
              conditionId: jbConditionId ? jbConditionId.conditionId : '',
              conditionName: jbConditionId ? jbConditionId.conditionName : '',
              startValue: jbConditionId ? jbConditionId.startValue : '',
              endValue: jbConditionId ? jbConditionId.endValue : '',
              roleId: jbConditionId ? jbConditionId.roleId : '',
              valueForApproval: valueForApproval ? valueForApproval : '',
              isAutoApproveFlag: values.jobcardTypeName === "FUEL" ? 1 : null
            })



          if (noErrorInForm) {
            Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/create`, jobcardData, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('apiToken')
              }
            }).then(response => {

              if (response.data.status === 1) {

                setSubmitting(false)
                cogoToast.success(response.data.message)
                window.location.href = '/jobcard'
                setisadded(false)
              } else {
                cogoToast.warn(response.data.message)
                setSubmitting(false)
                setisadded(false)
              }
            })
          } else {
            setSubmitting(false)
            setisadded(false)
          }
        }}
      >
        {({ values, errors, touched, isSubmitting, setFieldValue, handleSubmit }) => {

          values.subTotal = Number(values.productDetails.sum("amount")).toFixed(2)

          values.finalAmount = values.adjustmentAmount ? Number(values.subTotal - values.adjustmentAmount).toFixed(2) : values.subTotal

          return (
            <>
            <Formiker>
              <div className="m-2">
                {switchOff ?
                  <Message warning>
                    <Message.Header>Alert! {latestHistory.length > 0 ? latestHistory[0].vehicle_obj.vehicleNo : ''} is already Created!!</Message.Header>
                    <p>Please Select Different Vehicle</p>
                  </Message>
                  : ''
                }
                <Segment>
                  <div className="ui form tiny">
                    <FormUi.Group>
                      <FormUi.Field >
                        <label className="labelName w3-text-blue">Basic Details</label>
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width={4}>
                        <label className="labelName">{jobcardTitles.JOBCARD_TYPE} *</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik
                          autoComplete="off"
                          component={MyJobcardType}
                          removeProductFromlist={removeProductFromlist}
                          error={values.jobcardType ? false : true}
                          name="jobcardType"
                          typeName="jobcardTypeName"
                          listAllValues={values}
                          value={values.jobcardType} />
                        {touched.jobcardType && errors.jobcardType ? <div className="w3-tiny w3-text-red p-bold-600">{errors.jobcardType}</div> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={3}>
                        <label className="labelName">{jobcardTitles.REF_NO}</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik autoComplete="off" component={MyInput} /* error={values.refNo ? false : true} */ name="refNo" placeholder="Ref No." />
                        {touched.refNo && errors.refNo ? <div className="w3-tiny w3-text-red p-bold-600">{errors.refNo}</div> : ''}
                      </FormUi.Field>
                    </FormUi.Group>

                    {values.jobcardTypeName == "BATTERY" || values.jobcardTypeName == "TYRE" ?
                      <FormUi.Group >
                        <FormUi.Field width={4}>
                          <label className="labelName">{jobcardTitles.JOBCARD_ACTIVITY}</label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <Fieldmik
                            autoComplete="off"
                            style={{ width: '100%' }}
                            component={JobcardActivity}
                            name="jobcardActivity"
                            typeJobcardActivity={values.jobcardType}
                            type="" />

                          {touched.jobcardActivity && errors.jobcardActivity ? <div className="w3-tiny w3-text-red p-bold-600">{errors.jobcardActivity}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      : null}

                    <FormUi.Group >
                      <FormUi.Field width={4}>
                        <label className="labelName">{jobcardTitles.VEHICLE_NO} *</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik
                          autoComplete="off"
                          placeholder="Vehicle No."
                          error={values.vehicleNumber ? false : true}
                          name="vehicleNumber"
                          setvehicleInfo={setvehicleInfo}
                          setBatteryInfo={setBatteryInfo}
                          component={MyVehicleNumber}
                          jobcardActivity={values?.jobcardActivity}
                          setVehicleSelected={setVehicleSelected}
                          blockVehicle={blockVehicle}
                        />
                        {touched.vehicleNumber && errors.vehicleNumber ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleNumber}</div> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={3}>
                        <label className="labelName">{jobcardTitles.VEHICLE_TYPE}</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik readOnly autoComplete="off" name="vehicleType" value={vehicleInfo.length > 0 ? vehicleInfo[0].vehicleType : ''} />
                        {touched.vehicleType && errors.vehicleType ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleType}</div> : ''}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group >
                      <FormUi.Field width={4}>
                        <label className="labelName">{jobcardTitles.METER_READING}</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik type="number" autoComplete="off" min={1} name="meterReading" placeholder="" />
                        {/* {latestHistory.length > 0 ? <div className="w3-tiny w3-text-red p-bold-600">Should be Greater Than {latestHistory[0].meterReading ? latestHistory[0].meterReading : 0}</div> : ''} */}
                        {touched.meterReading && errors.meterReading ? <div className="w3-tiny w3-text-red p-bold-600">Should be Greater Than {latestHistory?.[0]?.meterReading ? latestHistory[0].meterReading : 0}</div> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={3}>
                        <label className="labelName">{jobcardTitles.BRANCH} *</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik autoComplete="off" placeholder="Branch" gstAvailable="gstExempted" name="branch" error={values.branch ? false : true} component={MyBranch} />
                        {touched.branch && errors.branch ? <div className="w3-tiny w3-text-red p-bold-600">{errors.branch}</div> : ''}
                      </FormUi.Field>
                    </FormUi.Group>

                    <FormUi.Group>
                      <FormUi.Field width={4}>
                        {values?.jobcardTypeName?.toLocaleLowerCase() === "fuel" ?
                          <label className="labelName">{jobcardTitles.VEHICLE_EXPENSE_DATE} *</label>
                          :
                          <label className="labelName">{jobcardTitles.VEHICLE_IN_DATE} *</label>
                        }
                      </FormUi.Field>
                      <FormUi.Field className="datepic" width={3}>
                        <DateData
                          name="inDate"
                          autoComplete="off"
                          popperClassName="dateTime"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="In Date"
                          selected={values.inDate}
                          selectsStart
                          startDate={values.inDate}
                          endDate={values['outDate']}
                          timeIntervals={5}
                          customInput={<FormUi.Input error={values.inDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                        />
                        {touched.inDate && errors.inDate ? <div className="w3-tiny w3-text-red p-bold-600">{errors.inDate}</div> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      {values?.jobcardTypeName?.toLocaleLowerCase() == "fuel" ?
                        <>
                          <FormUi.Field width={3}>
                            <label className="labelName">{jobcardTitles.VENDOR} *</label>
                          </FormUi.Field>
                          <FormUi.Field width={3}>
                            <Fieldmik autoComplete="off" placeholder="Select Vendor" name="dealer" component={MyVendor} />
                            {touched.dealer && errors.dealer ? <div className="w3-tiny w3-text-red p-bold-600">{errors.dealer}</div> : ''}
                          </FormUi.Field>
                        </>
                        : <>
                          <FormUi.Field width={3}>
                            <label className="labelName">{jobcardTitles.VEHICLE_OUT_DATE} *</label>
                          </FormUi.Field>
                          <FormUi.Field className="datepic" width={3}>
                            <DateData
                              name="outDate"
                              selected={values.name}
                              selectsEnd
                              startDate={values['inDate']}
                              endDate={values.name}
                              minDate={values['inDate']}
                              autoComplete="off"
                              popperClassName="dateTime"
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Out Date"
                              timeIntervals={5}
                              customInput={<FormUi.Input autoComplete="off" icon="time" className="dateWidth" iconPosition="left" />}
                            />
                            {touched.outDate && errors.outDate ? <div className="w3-tiny w3-text-red p-bold-600">{errors.outDate}</div> : ''}
                          </FormUi.Field>
                        </>}
                    </FormUi.Group>

                    {values?.jobcardTypeName?.toLocaleLowerCase() == "fuel" ?
                      <>
                      </>
                      :
                      <>
                        <FormUi.Group >
                          <FormUi.Field width={4}>
                            <label className="labelName">{jobcardTitles.VENDOR} *</label>
                          </FormUi.Field>
                          <FormUi.Field width={3}>
                            <Fieldmik autoComplete="off" placeholder="Select Vendor" name="dealer" component={MyVendor} />
                            {touched.dealer && errors.dealer ? <div className="w3-tiny w3-text-red p-bold-600">{errors.dealer}</div> : ''}
                          </FormUi.Field>
                        </FormUi.Group>
                      </>
                    }

                  </div>
                </Segment>
                {/*  </div>
                            </div> */}

                {/* <div className="container-fluid pad w3-white">
                                <div className="p-2"> */}
                <Segment>
                  <div className="ui form subform tiny">
                    <FormUi.Group >
                      <FormUi.Field >
                        <label className="labelName w3-text-blue">Bill Details</label>
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group >
                      <FormUi.Field width={4}>
                        <label className="labelName">Quotation No</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik autoComplete="off" name="quotationNumber" placeholder="Quotation No." />
                        {touched.quotationNumber && errors.quotationNumber ? <div className="w3-tiny w3-text-red p-bold-600">{errors.quotationNumber}</div> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={3}>
                        <label className="labelName">Quotation Amount</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik autoComplete="off" name="quotationAmount" placeholder="Amount" />
                        {touched.quotationAmount && errors.quotationAmount ? <div className="w3-tiny w3-text-red p-bold-600">{errors.quotationAmount}</div> : ''}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group >
                      <FormUi.Field width={4}>
                        <label className="labelName">Quotation</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik autoComplete="off" name="quotation" type="file" id="quotation" buttonName={values.quotation ? 'File Selected' : "Choose File"} placeholder="Quotation" className="subform" component={UploadFile} typer={['.pdf']} />
                        {touched.quotation && errors.quotation ? <div className="w3-tiny w3-text-red p-bold-600">{errors.quotation}</div> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={1} />

                      <FormUi.Field width={3}>
                        <label className="labelName">Vendor Bill File</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <div className='display-flex-nospace'>
                          <Fieldmik name="invoiceUpload" placeholder="Note" buttonName={values.invoiceUpload ? 'File Selected' : "Upload File"} component={UploadFile} typer={['.pdf']} />
                        </div>
                        {touched.invoiceUpload && errors.invoiceUpload ? <div className="w3-tiny w3-text-red p-bold-600">{errors.invoiceUpload}</div> : ''}

                      </FormUi.Field>

                    </FormUi.Group>
                    <FormUi.Group >
                      <FormUi.Field width={4}>
                        <label className="labelName">Bill No. *</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik onKeyUp = {(e) => checkInvoiceNo(e)}  autoComplete="off" name="invoiceNumber" placeholder="Bill No" />
                        {touched.invoiceNumber && errors.invoiceNumber ? <div className="w3-tiny w3-text-red p-bold-600">{errors.invoiceNumber}</div> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={3}>
                        <label className="labelName">Bill Date</label>
                      </FormUi.Field>
                      <FormUi.Field className="datepic" width={3}>
                        <DateData
                          name="invoiceDate"
                          isClearable={true}
                          autoComplete="off"
                          popperClassName="dateTime"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Date"
                          timeIntervals={5}
                          minDate={values.inDate}
                          customInput={<Input autoComplete="off" icon="time" className="dateWidth2" iconPosition="left" />}
                        />
                        {touched.invoiceDate && errors.invoiceDate ? <div className="w3-tiny w3-text-red p-bold-600">{errors.invoiceDate}</div> : ''}
                      </FormUi.Field>

                    </FormUi.Group>
                  </div>
                </Segment>

                {values.jobcardTypeName === "BATTERY" && values.inDate && vehicleInfo.length > 0 && (values?.jobcardActivity == 4 || values?.jobcardActivity == 5 || values?.jobcardActivity == 6) ?
                  <Battery
                    vehicleIdrole={values.vehicleNumber}
                    batteryInfo={batteryInfo}
                    conditionRoleId={getRoleId}
                    cardTypeId={values.jobcardType}
                    vehicleInfoarray={vehicleInfo}
                    jbValues={values}
                    vehicleInDate={values.inDate}
                    jbConditionId={getJbConditionId}
                    valueForApproval={getValueForApproval}
                  />
                  : ""
                }

                {(values.jobcardTypeName === "SERVICES" || values.jobcardTypeName === "FUEL" || values.jobcardTypeName === "REPAIR") && vehicleInfo.length > 0 ?
                  <Services
                    valuesSent={values}
                    cardTypeId={values.jobcardType}
                    vehicleIdrole={values.vehicleNumber}
                    conditionRoleId={getRoleId}
                    amount={values.finalAmount}
                    jbConditionId={getJbConditionId}
                    valueForApproval={getValueForApproval}
                  />
                  :
                  ""
                }

                {values.jobcardTypeName === "TYRE" && vehicleInfo.length > 0 && (values?.jobcardActivity == 1 || values?.jobcardActivity == 2 || values?.jobcardActivity == 3) ?
                  <Tyre
                    vehicleIdrole={values.vehicleNumber}
                    conditionRoleId={getRoleId}
                    cardTypeId={values.jobcardType}
                    vehicleInfoarray={vehicleInfo}
                    jbValues={values}
                    maxTyreRun={values.tyreRun}
                    tyreDetails={getTyrNo}
                    jbConditionId={getJbConditionId}
                    valueForApproval={getValueForApproval}
                  />
                  :
                  ""
                }

                <Segment>
                  <div className="ui form subform tiny">
                    <AddProduct jobcardTypeName={values.jobcardTypeName} modeView={2} />

                    <div className="ui form subform tiny">
                      <Segment className="mt-4">
                        <FormUi.Group widths="2">
                          <FormUi.Field>
                            <label>Notes</label>
                            <Fieldmik as="textarea" rows="3" name="customerNotes" placeholder="Enter Notes" />
                            {touched.customerNotes && errors.customerNotes ? <div className="w3-tiny w3-text-red p-bold-600">{errors.customerNotes}</div> : ''}
                          </FormUi.Field>
                          {/* <Divider vertical><span className="labelName w3-text-light-grey">|</span></Divider> */}

                        </FormUi.Group>
                      </Segment>
                    </div>
                  </div>
                </Segment>
                <center><Button disabled={isSubmitting || switchOff || billNoExists } primary size="mini" type="submit">Submit</Button></center>

                {values.vehicleNumber && <JobcardHistory vehicleHistoryId={values.vehicleNumber} vehicleInfoarray={vehicleInfo} getLatestHistory={fetchLatestHistory} setFieldValue={setFieldValue} />}
              </div>
            </Formiker>
                </>
          )
        }}
      </Formik>
    </>
  )
}